import { format } from "date-fns";
import { Cell, Column } from "react-table";

import nameof from "../../../helpers/nameof";
import { Event } from "../../../../api";

import TextFilter from "../Components/Filtering/TextFilter";
import MultiSelectFilter from "../Components/Filtering/MultiSelectFilter";

const Columns: Column<Event>[] = [{
  Header: "Date",
  Footer: "Date",
  Cell: ({ value }: Cell) => {
    return format(new Date(value), "dd/MM/yyyy");
  },
  accessor: nameof<Event>("start"),
  width: "10%",
}, {
  Header: "Name",
  Footer: "Name",
  Filter: TextFilter,
  accessor: nameof<Event>("name"),
}, {
  Header: "Round",
  Footer: "Round",
  Filter: TextFilter,
  accessor: nameof<Event>("round"),
}, {
  Header: "Type",
  Footer: "Type",
  filter: "multiSelect",
  Filter: MultiSelectFilter,
  accessor: nameof<Event>("type"),
  disableSortBy: true,
}, {
  Header: "No. of Registrations",
  Footer: "No. of Registrations",
  accessor: event => event.totalRegistrations,
  width: "10%",
}, {
  Header: "No. of Attendees",
  Footer: "No. of Attendees",
  accessor: event => event.attendance?.total,
  width: "10%",
}, {
  Header: "Content Score",
  Footer: "Content Score",
  accessor: event => event.scores?.content,
  width: "10%",
}, {
  Header: "Presenter Score",
  Footer: "Presenter Score",
  accessor: event => event.scores?.presenter,
  width: "10%",
}];

export default Columns;
